<template>
    <div class="about">
        <chapter tag="h1" class="ribbon">{{ lesson.name }} {{ lesson.base_classe }}</chapter>
        <chapter tag="h3" class="ribbon">
            {{ topic.title }} <small v-if="videos.length">[{{ videos.length }} відео]</small>
        </chapter>

        <div v-if="videos.length">
            <a v-for="(video, index) in videos" :key="index" href="#" @click="onClickByVideo(video, $event)">
                <div>
                    <span>Код: {{ video.code }}</span>.&nbsp; <span>{{ video.title }}</span>
                </div>
            </a>
        </div>

        <!--<mdb-btn color="primary" >Launch demo modal</mdb-btn>-->
        <mdb-modal v-if="modal" @close="onCloseVideo" size="lg">
            <mdb-modal-header>
                <mdb-modal-title>
                    <span>Код: {{ currentVideo.code }}</span>. <span>{{ currentVideo.title }}</span>
                </mdb-modal-title>
            </mdb-modal-header>
            <mdb-modal-body>
                <!--<video-frame :url="currentVideo.url_youtube" />-->
                <video-frame :url="currentVideo.url_vimeo" />
            </mdb-modal-body>
            <mdb-modal-footer>
                <mdb-btn color="secondary" @click.native="modal = false">Закрити</mdb-btn>
            </mdb-modal-footer>
        </mdb-modal>
    </div>
</template>

<script>
    //import Vue from 'vue';
    //Vue.component('math-lessons', () => import(/* webpackChunkName: "math-lessons" */ '~/components/math-lessons'));

    export default {
        name: 'math-topic-page',
        data() {
            return {
                modal:  false,
                currentVideo: {},
                lesson: {},
                topic:  {},
                videos: [],
            };
        },
        mounted() {
            this.renderTopic();
        },
        methods: {
            renderTopic() {
                api.get(`public/topics/${this.$route.params.id}`).then(response => {
                    this.lesson = response.data.lesson;
                    this.topic = response.data.topic;
                    this.videos = response.data.videos;
                    //this.$emit('afterVideoSearch', this.packageItem);
                });
            },
            onClickByVideo(video, e) {
                e.preventDefault();

                this.modal = true;
                this.currentVideo = video;

                console.log('DEBUG: currentVideo:', this.currentVideo);
            },
            onCloseVideo() {
                this.modal = false;
                this.currentVideo = {};
            }
        }
    }
</script>
